import type { IncomingMessage, ServerResponse } from 'http'
import get from 'lodash/get'
import { useRouter } from 'next/router'
import objectScan from 'object-scan'
import qs from 'query-string'
import { ParsedUrlQuery } from 'querystring'

export const scanGet = <T = any>(obj: any, glob: string[]): T | undefined => {
  const path = objectScan(glob)(obj)
  return get(obj, path[0])
}

export interface CartDefaults {
  tableArea?: string
  tableNumber?: string
  googlePlaceId?: string
}

export const useCartDefaults = (): CartDefaults => {
  const { query } = useRouter()
  const defaults: CartDefaults = {}

  if (query.number || query.area) {
    defaults.tableArea = query.area ? String(query.area) : ''
    defaults.tableNumber = query.number
      ? String(query.number).toUpperCase()
      : ''
  }

  if (query.place) {
    defaults.googlePlaceId = query.place ? String(query.place) : ''
  }

  return defaults
}

export const getCleanPath = (url: string, query?: ParsedUrlQuery) =>
  qs.stringifyUrl({
    url,
    query: {
      ...query,
      orderToken: undefined,
      afterpay: undefined,
      status: undefined,
      number: undefined,
      area: undefined,
      place: undefined,
    },
  })

export const formatPoints = (points: number | undefined) => {
  if (!points) return '0'

  return points.toLocaleString(undefined, {
    maximumFractionDigits: 2,
  })
}

export const getCookieValue = (cookies: string, cookieName: string) => {
  const cookie = cookies
    .split(';')
    .map((v) => v.trim().split('='))
    .find((v) => v[0] === cookieName)

  if (cookie) {
    return cookie.length > 1 ? cookie[1] : ''
  }

  return undefined
}

export const appendSetCookie = (res: ServerResponse, setCookie: string) => {
  const previousSetCookie = res.getHeader('set-cookie')
  if (previousSetCookie) {
    res.setHeader(
      'set-cookie',
      Array.isArray(previousSetCookie)
        ? [...previousSetCookie, setCookie]
        : [`${previousSetCookie}`, setCookie],
    )
    return
  }

  res.setHeader('set-cookie', setCookie)
}

export const appendCookie = (req: IncomingMessage, cookie: string) => {
  const previousCookie = req.headers['cookie']
  if (previousCookie) {
    req.headers['cookie'] = `${previousCookie}; ${cookie}`
    return
  }

  req.headers['cookie'] = cookie
}
